import type { PropsWithChildren } from "react";

import { TextTestID } from "@/constants/TestID";
import { ActionBar, FAIconName } from "@/ui/core";
import { HStack } from "@/ui/layout";
import { joinTestIDs } from "@/utils/string.util";

const BannerContainer = ({ children }: PropsWithChildren) => {
  return (
    <HStack justifyContent="center" paddingHorizontal={16} paddingTop={8}>
      {children}
    </HStack>
  );
};

type FrozenChannelBannerProps = ViewWithTestID;

const FrozenChannelBanner = ({ testID }: FrozenChannelBannerProps) => {
  return (
    <BannerContainer>
      <ActionBar
        align="center"
        iconName={FAIconName.ExclamationCircle}
        message="This channel is no longer active."
        size="medium"
        testID={joinTestIDs(testID, "frozen-channel", TextTestID.Text)}
        variant="warning"
      />
    </BannerContainer>
  );
};

export { FrozenChannelBanner };
